

















import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { IContentSetVersion } from "../../../models/interfaces/content/content-set-version.model.interface";
import { IContentSetVersionTemplate } from "../../../models/interfaces/content/content-set-version-template.model.interface";
import { formatService } from "../../../services/format.service";
import { StatusType } from "../../../enums/StatusType";

@Component({
  components: {}
})
export default class ContentConfiguration extends Vue {

    get getVersion(): IContentSetVersion {
        return this.version;
    }

    @Prop() public version: IContentSetVersion;

    private dateDiff: number;
    private livePeriod: number;

    @Watch("getVersion", { deep: true })
    public onContentSetVersionUpdate() {
        this.setDates();
    }

    public created() {
        this.setDates();
    }

    private setDates() {
        this.dateDiff = formatService.getDateDiff(this.version.startDate);

        this.livePeriod = formatService.calculatePeriod(
            this.version.startDate,
            this.version.endDate
        );
    }
}
